import { Container } from '@mui/material'
import React from 'react'
import { SectionHeading, SectionWrapper } from '../../../Styles/style'

import Accordian from "./components/Accordian"
const S7_Faqs = () => {

    return (
        <div>
            <SectionWrapper p="4rem 0" id="tokenomics">
                <Container maxWidth="xl" data-aos="fade-up"
                    data-aos-easing="ease-in"
                    data-aos-delay="400"
                    data-aos-offset="0"
                    data-aos-duration="1000">
                    <SectionHeading p="40px 0" align="center" data-aos="zoom-in"
                        data-aos-easing="ease-in"
                        data-aos-delay="500"
                        data-aos-offset="0"
                        data-aos-duration="1000">FAQ
                    </SectionHeading>
                    <Accordian />
                </Container>
            </SectionWrapper>
        </div>
    )
}

export default S7_Faqs